import { render, staticRenderFns } from "./AskGovDetail.vue?vue&type=template&id=d7f08a8e&scoped=true&"
import script from "./AskGovDetail.vue?vue&type=script&lang=ts&"
export * from "./AskGovDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AskGovDetail.vue?vue&type=style&index=0&id=d7f08a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f08a8e",
  null
  
)

export default component.exports